<template>
  <RouterView />
  <Transition name="fade">
    <div v-show="scY > 250" class="fixed right-4 bottom-4">
      <VaButton round class="drop-shadow-md hover:drop-shadow-lg" @click="toTop">
        <VaIcon name="keyboard_double_arrow_up" :size="30" title="back to top" />
      </VaButton>
    </div>
  </Transition>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'

const scTimer = ref(0)
const scY = ref(0)

const handleScroll = () => {
  if (scTimer.value) return
  scTimer.value = setTimeout(() => {
    scY.value = window.scrollY
    clearTimeout(scTimer.value)
    scTimer.value = 0
  }, 100)
}

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})
</script>

<style lang="scss">
@import 'scss/main.scss';

#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
